var defaultEntity = {
    NAF: '',
    activity: '',
    address: {
        address: '',
        city: '',
        country: '',
        zipCode: '',
    },
    capitalSocial: 0,
    codeCurrency: '',
    companyGroup: {
        country: '',
        parentCompanyGroup: '',
        subsidiaryCompanies: '',
        status: false,
    },
    created: '',
    currency: {
        code: '',
        name: '',
        names: '',
        symbol: '',
    },
    defaultInvestment: false,
    expired: false,
    financialInstitution: {
        GIIN: '',
        authority: '',
        created: '',
        homeCountry: '',
        idEntity: 0,
        institutionType: '',
        license: '',
        regulatoryStatus: '',
        regulatoryWebsite: '',
        status: false,
    },
    formJuridique: '',
    id: 0,
    idAddress: 0,
    incorporation: {
        created: '',
        idEntity: 0,
        incorporation: '',
        incorporationForm: 'other',
        status: false,
        updated: '',
    },
    isConfig: false,
    iss_user: 0,
    language: '',
    legalName: '',
    lei: {
        created: '',
        idEntity: 0,
        leiCode: '',
        leiStatus: '',
        status: false,
        updated: '',
    },
    number: '',
    otherLicense: {
        authority: '',
        country: '',
        created: '',
        idEntity: 0,
        license: '',
        status: false,
        updated: '',
    },
    rcsCity: '',
    rolePerson: '',
    siren: '',
    siret: '',
    societyName: '',
    startingExercise: '',
    status: 'incomplete',
    tag: 'p2p',
    tva: '',
    ubo: '',
    updated: '',
    vat_rate: 0,
    website: '',
};
export default defaultEntity;
